import React, { forwardRef } from 'react';
import styled from 'styled-components';
import ActionBar from '../ActionBar';

const ActionBarContainer = styled.div`
  position: fixed;
  visibility: visible;
  > div {
    position: absolute;
    top: 89px;
    left: 10px;
  }
`;

interface OwnProps {
  slug: string;
  path: string;
  shareCount: number;
}

const StickyActionBar = forwardRef<HTMLDivElement, OwnProps>(
  ({ slug, path, shareCount }, ref) => (
    <ActionBarContainer ref={ref}>
      <div>
        <ActionBar slug={slug} path={path} vertical shareCount={shareCount} />
      </div>
    </ActionBarContainer>
  ),
);

export default StickyActionBar;
